<template>
  <div>
    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">
      <el-form-item label="物料编码"><el-input v-model="query.materialCode" size="small" clearable style="width:140px" /></el-form-item>
      <el-form-item label="工艺编码"><el-input v-model="query.routingCode" size="small" clearable style="width:140px" /></el-form-item>
      <el-form-item label="工艺名称"><el-input v-model="query.routingName" size="small" clearable style="width:140px" /></el-form-item>
      <el-form-item label="发布状态">
        <el-select v-model="query.releaseStatus" clearable size="small" style="width:110px">
          <el-option label="未发布" value="0" />
          <el-option label="已发布" value="1" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('plm:plmRoutingRelease:list')" type="primary" size="small" @click="search">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="pageList" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
      <el-table-column prop="routingCode" label="工艺编码" min-width="120" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="routingName" label="工艺名称" min-width="140" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="routingVersion" label="版本" width="80" header-align="center" align="center" />
      <el-table-column label="专用物料" min-width="160" header-align="center" align="left" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.materialCode">{{ scope.row.materialCode }} / {{ scope.row.materialName }}</span>
          <span v-else class="text-muted">—</span>
        </template>
      </el-table-column>
      <el-table-column prop="releaseStatus" label="发布状态" width="90" header-align="center" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.releaseStatus === '1' ? 'success' : 'info'" size="mini">
            {{ scope.row.releaseStatus === '1' ? '已发布' : '未发布' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="isenabled" label="启用" width="70" header-align="center" align="center">
        <template slot-scope="scope">{{ scope.row.isenabled === '0' ? '是' : '否' }}</template>
      </el-table-column>
      <el-table-column label="操作" width="100" header-align="center" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button v-if="isAuth('plm:plmRoutingRelease:release')" type="text" size="small" :disabled="!canRelease(scope.row)" @click="openRelease(scope.row)">发布</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="total"
      layout="total, sizes, prev, pager, next, jumper" @size-change="s => { pageSize = s; pageIndex = 1 }" @current-change="p => { pageIndex = p }" />

    <el-dialog title="发布工艺" :visible.sync="releaseVisible" width="min(420px, calc(100vw - 24px))" append-to-body>
      <el-form label-width="100px">
        <el-form-item label="工艺"><el-input :value="(releaseRow.routingCode || '') + ' / ' + (releaseRow.routingName || '')" disabled /></el-form-item>
        <el-form-item label="版本"><el-input :value="releaseRow.routingVersion || 'V1'" disabled /></el-form-item>
        <el-form-item v-if="!releaseRow.materialId" label="目标物料" required>
          <el-input v-model="releaseMaterialCode" readonly placeholder="点击选择">
            <el-button slot="append" @click="materialSelectorVisible = true">选择</el-button>
          </el-input>
        </el-form-item>
        <el-form-item v-else label="目标物料">
          <el-input :value="(releaseRow.materialCode || '') + ' / ' + (releaseRow.materialName || '')" disabled />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="releaseVisible = false">取消</el-button>
        <el-button type="primary" :loading="releaseLoading" @click="submitRelease">确认发布</el-button>
      </span>
    </el-dialog>
    <material-selector :visible.sync="materialSelectorVisible" :multiple="false" @select="onMaterialSelect" />
  </div>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import MaterialSelector from '../../components/MaterialSelector'

export default {
  name: 'PlmRoutingRelease',
  components: { MaterialSelector },
  data() {
    return {
      query: { materialCode: '', routingCode: '', routingName: '', releaseStatus: '' },
      list: [], pageIndex: 1, pageSize: 20, loading: false, permCodes: [],
      releaseVisible: false, releaseLoading: false, releaseRow: {},
      releaseMaterialId: '', releaseMaterialCode: '', materialSelectorVisible: false,
      headStyle: { background: '#f5f7fa', color: '#606266', textAlign: 'center' }
    }
  },
  computed: {
    filtered() {
      return this.list.filter(row => {
        return this.has(row.materialCode, this.query.materialCode)
          && this.has(row.routingCode, this.query.routingCode)
          && this.has(row.routingName, this.query.routingName)
          && (!this.query.releaseStatus || row.releaseStatus === this.query.releaseStatus)
      })
    },
    total() { return this.filtered.length },
    pageList() { return this.filtered.slice((this.pageIndex - 1) * this.pageSize, this.pageIndex * this.pageSize) }
  },
  created() { this.loadPerms(); this.load() },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    has(value, keyword) {
      const text = String(keyword || '').trim().toLowerCase()
      if (!text) return true
      return String(value || '').toLowerCase().indexOf(text) >= 0
    },
    canRelease(row) {
      if (!row || row.isenabled !== '0') return false
      if (row.releaseStatus === '1' && row.materialId) return false
      return true
    },
    search() { this.pageIndex = 1; this.load() },
    load() {
      this.loading = true
      request.get('/plm/routing/list').then(res => { this.list = res.data || [] }).catch(() => { this.list = [] }).finally(() => { this.loading = false })
    },
    openRelease(row) {
      this.releaseRow = row || {}
      this.releaseMaterialId = row.materialId || ''
      this.releaseMaterialCode = row.materialCode || ''
      this.releaseVisible = true
    },
    onMaterialSelect(row) {
      this.releaseMaterialId = row.materialId
      this.releaseMaterialCode = row.materialCode
    },
    submitRelease() {
      const materialId = this.releaseRow.materialId || this.releaseMaterialId
      if (!materialId) {
        this.$message.warning('请选择目标物料')
        return
      }
      this.releaseLoading = true
      request.post('/plm/plmRoutingRelease/release', {
        routingId: this.releaseRow.routingId || this.releaseRow.id,
        materialId
      }).then(() => {
        this.$message.success('工艺已发布，物料默认工艺已更新')
        this.releaseVisible = false
        this.load()
      }).catch(() => {}).finally(() => { this.releaseLoading = false })
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 12px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
.text-muted { color: #909399; }
</style>
